import { render, staticRenderFns } from "./Step2Desktop.vue?vue&type=template&id=87051038&scoped=true&"
import script from "./Step2Desktop.vue?vue&type=script&lang=js&"
export * from "./Step2Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Step2Desktop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Step2Desktop.vue?vue&type=style&index=1&id=87051038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87051038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87051038')) {
      api.createRecord('87051038', component.options)
    } else {
      api.reload('87051038', component.options)
    }
    module.hot.accept("./Step2Desktop.vue?vue&type=template&id=87051038&scoped=true&", function () {
      api.rerender('87051038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Step2Desktop.vue"
export default component.exports